/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TargetKeyEcologicalAttributeWithIndicatorTaxonomyClassifications } from './targetKeyEcologicalAttributeWithIndicatorTaxonomyClassifications';


/**
 * Project Target KEA Indicator Taxonomy Classifications
 */
import { ValidateUtils } from 'app/shared/utils';

export class ProjectTargetKeyEcologicalAttributeWithIndicatorTaxonomyClassifications { 
    /**
     * Unique identifier for Project
     */
    readonly projectIdentifier?: string;
    /**
     * Project name
     */
    readonly projectName?: string;
    /**
     * Targets KEAs (including Indicator Taxonomy Classifications) for Project
     */
    targets?: Array<TargetKeyEcologicalAttributeWithIndicatorTaxonomyClassifications>;

    constructor(item?: Partial<ProjectTargetKeyEcologicalAttributeWithIndicatorTaxonomyClassifications>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            projectIdentifier: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.projectIdentifier : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            projectName: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.projectName : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            targets: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.targets : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: ProjectTargetKeyEcologicalAttributeWithIndicatorTaxonomyClassifications.isValid,
        };
    }

    static isValid(obj: ProjectTargetKeyEcologicalAttributeWithIndicatorTaxonomyClassifications): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = ProjectTargetKeyEcologicalAttributeWithIndicatorTaxonomyClassifications.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.projectIdentifier.isValid(item);
            result = result && validationObject.projectName.isValid(item);
            result = result && validationObject.targets.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

